import { Row, Col, Dropdown, Form } from "react-bootstrap";
import { useAppSelector, useAppDispatch } from "redux/hooks";
import { RootState } from "redux/store";
import { addAGGridSelectedStocks, updateCatalogueField, updateCatalogueModelField } from "redux/slices/Catalogues";
import { useProductFilter } from "hooks";
import { useEffect, useRef, useState } from "react";
import { ImportWizard } from "components";
import { getCatalogueDetails, getCatalogueStores } from "redux/slices/Catalogues";
import { getProducts } from "redux/slices/Products";
import { getRowIds, ParseAndValidateFloat, ToFixedNotRounded } from "helpers/data/dataHandling";
import { CatalogueImportWorkerData, CatalogueImportWorkerResponseData } from "./catalogueImportWorker";
import { runBatchWorkers } from "components/WebWorkers/ZWebWorker";
import { ManagedStocksPopup } from "popups/ManagedStocks/ManagedStocks";
import { getStockTable, getStockTableOptimised } from "redux/slices/Stocks";
import { ManagedCatalogueStockView } from "models/dbModels/nanagedCatalogues/ManagedCatalogueStock";
import { AgGridReact } from "ag-grid-react";
import BaseCellRenderer from "components/AgGrid/CellRenderers/BaseCellRenderer";
import { getCatalogStockCoverPage, getCatalogStockCsvDataFormatter, getCatalogStockDataFormatter, getCatalogueStocksConfig } from "TableConfigs/CatalogueStocksConfig";
import MoneyCellEditor from "components/AgGrid/CellEditors/MoneyCellEditor";
import EditablePriceCellRenderer from "components/AgGrid/CellRenderers/EditablePriceCellRenderer";
import EditablePercentCellRenderer from "components/AgGrid/CellRenderers/EditablePercentCellRenderer";
import PercentCellEditor from "components/AgGrid/CellEditors/PercentCellEditor";
import { AgGridToolbar, AgGridToolbarRef } from "components/AgGrid/AgGridToolbar";
import { ZIconType } from "helpers/utility/iconMap";
import { Z } from "models/common/components";
import { ZTooltip } from "components/ZTooltip";
import { ZIcon } from "components/ZIcon";
import {CatalogueDeletePopup} from "../Popups/CatalogueDeletePopup";
import { CatalogueBulkEditPopup } from "../Popups/CatelogueBulkEdit";
import { ManagedStockApn } from "models/dbModels/managedStock/ManagedStockApn";
import { ManagedStockPde } from "models/dbModels/managedStock/ManagedStockPde";

export default function Stocks() {
    const dispatch = useAppDispatch();
    const [importPercentage, setImportPercentage] = useState<number>(0);
    const catalogue = useAppSelector((state: RootState) => state.catalogues);
    const user = useAppSelector((state: RootState) => state.logedinUser);
	const stocks = useAppSelector((state: RootState) => state.stocks);
    const catelogueStocksGridRef = useRef<AgGridReact>(null);
    const [newStockList, setNewStockList] = useState<any[]>([]);
    const [catalogueTableData, setCatalogueTableData] = useState<ManagedCatalogueStockView[]>([]);
    const toolbarRef = useRef<AgGridToolbarRef>(null);
    const [showDeletePopup, setShowDeletePopup] = useState<boolean>(false);
    const [showBulkEditPopup, setShowBulkEditPopup] = useState<boolean>(false);
    const [isDeletingSelectedStock, setIsDeletingSelectedStock] = useState<boolean>(false);
    const [apnList, setApnList] = useState<ManagedStockApn[]>([]);
    const [pdeList, setPdeList] = useState<ManagedStockPde[]>([]);
    const [searchApnList, setSearchApnList] = useState<boolean>(false);
    const [searchPdeList, setSearchPdeList] = useState<boolean>(false);
    let data = []

    useEffect(()=>{
        if(catalogueTableData.length == 0){
            dispatch(addAGGridSelectedStocks([]));
            setCatalogueTableData(getEditableManagedCatalogueStockView());
            setApnList(catalogue.model.apns);
            setPdeList(catalogue.model.pdes);
        }
        if (catalogue.model.catalogueStocks.length == 0 && catelogueStocksGridRef.current != null && catelogueStocksGridRef.current?.api != undefined){
            catelogueStocksGridRef.current?.api.showNoRowsOverlay();
        }
    },[catalogue.model.catalogueStocks])

    function getEditableManagedCatalogueStockView(): ManagedCatalogueStockView[] {
        let newData: ManagedCatalogueStockView[] = [];
        catalogue.model.catalogueStocks.forEach(da => {
            const manage:  ManagedCatalogueStockView = {
                name: da.name,
                catalogueId: da.catalogueId,
                managedStockId: da.managedStockId,
                storeStockId: da.storeStockId,
                description: da.description,
                type: da.type,
                quantity: da.quantity,
                value: Number(da.value),
                startDate: da.startDate,
                startTime: da.startTime,
                endDate: da.endDate,
                endTime: da.endTime,
            };
            newData.push(manage);
        });    
        if(newData.length == 0 && catelogueStocksGridRef.current != null && catelogueStocksGridRef.current?.api != undefined)
            catelogueStocksGridRef.current?.api.showNoRowsOverlay();
        return newData;
    }


    function reLoadTable() {
        if (catalogue.model.id) {
            dispatch(getCatalogueDetails(
                {
                    loadDetails: ["Stock", "Stores"],
                    ids: [catalogue.model.id]
                })).then((res) => {
                    dispatch(getCatalogueStores(
                        {
                            ids: [catalogue.model.catalogueId],
                            stores: res.stores,
                        })).then(()=> setCatalogueTableData(getEditableManagedCatalogueStockView()));
                });
        }
    }

    const CustomSearchButton = () => {
		return (
			<>
				<Dropdown.Item onClick={() => setSearchPdeList(!searchPdeList)}>
					<Form.Check type="checkbox" label="PDE" checked={searchPdeList} onChange={() => setSearchPdeList(!searchPdeList)} onClick={e => e.stopPropagation()}/>
				</Dropdown.Item>
				<Dropdown.Item onClick={() => setSearchApnList(!searchApnList)}>
					<Form.Check type="checkbox" label="APN" checked={searchApnList} onChange={() => setSearchApnList(!searchApnList)} onClick={e => e.stopPropagation()}/>
				</Dropdown.Item>
			</>
		);
	};

    function handleChange(option: any, optionValue: any) {
        dispatch(updateCatalogueField({ key: option, value: optionValue }));
    }

    function handleModelChange(option: any, optionValue: any) {
        dispatch(updateCatalogueModelField({ key: option, value: optionValue }));
    }

    function handleRemoval() {        
        const selectedStock = catelogueStocksGridRef.current?.api.getSelectedRows();
        const idList: number[] = [];
        selectedStock?.forEach((st: ManagedCatalogueStockView) => idList.push(st.managedStockId));
        setCatalogueTableData([]);
        const recordsNotDeleted = catalogue.model.catalogueStocks.filter((x)=> !idList.includes(x.managedStockId));        
        dispatch(updateCatalogueModelField({ key: "catalogueStocks", value: recordsNotDeleted }));

        setIsDeletingSelectedStock(false);
        setShowDeletePopup(false);
    }

    const importWizardExtraMatches = [
        {
            title: "Promo Price",
            key: "Price",
            required: true,
            validation: (value: any) => {
				let res = ParseAndValidateFloat(value, 0)
				if (res.output) {
					return { valid: true, error: "", newValue: ToFixedNotRounded(res.value, 2) }
				} else {
					return { valid: false, error: "Invalid Price" }
				}
			}
        }
    ]

    const terminateWorkersRef = useRef<Function>();

    async function importStockAsync(rows: any[]) {
        setCatalogueTableData([]);
        const webWorkerData: CatalogueImportWorkerData = {
			data: rows,
            stockList: [...catalogue.model.catalogueStocks]
		};

		const errors: Map<string, string> = new Map<string, string>();

		const { runWorkers, terminateWorkers } = runBatchWorkers<CatalogueImportWorkerData, any, CatalogueImportWorkerResponseData>({
            workerData: webWorkerData, 
            createWorker: () => new Worker(new URL('./catalogueImportWorker.ts', import.meta.url), { type: "module" }), 
            onWorkerResponse: (async (event, responseContext, httpErrors, reject) => {
                // There's no http call in this web worker but should we keep this in case? Probably not... hmm...
                if (!responseContext.response.data) {
                    if (httpErrors) {
                        const combinedError = httpErrors.join(", ");
                        // Now using this combined error, construct a { stockName, error } object for each stock and push it onto the errors array
                        responseContext.originalBatchData.forEach((r: any) => {
                            const errorEntry = errors.get(r.__name);
                            errors.set(r.__name ?? "", errorEntry ? errorEntry + ", " + combinedError : combinedError);
                        });
                    }
                } else {
                    setNewStockList(prev => {
                        console.log(responseContext.response.data!.updatedStocks);
                        handleModelChange("catalogueStocks", [...prev, ...responseContext.response.data!.updatedStocks]);
                        return [...prev, ...responseContext.response.data!.updatedStocks];
                    });
                }
                
				setImportPercentage((prev) => Math.min(100, prev + ((1 / responseContext.numBatches) * 100)));
            }), 
            onWorkersFinished: async (_) => setImportPercentage(0), 
            onWorkerError: (error, unprocessedData) => {
                unprocessedData.forEach(data => {
                    const errorEntry = errors.get(data.__name);
                    const errorMessage = error.message ?? "Unknown error occurred";
                    errors.set(data.__name ?? "", errorEntry ? errorEntry + ", " + errorMessage : errorMessage);
                })
            }
        });

        terminateWorkersRef.current = terminateWorkers;
        await runWorkers;

		const returnErrors: { stockName: string, error: string }[] = [];

		errors.forEach((value: string, key: string) => {
			returnErrors.push({
				stockName: key,
				error: value,
			})
		});

		return [...returnErrors];
    }

    async function saveSelectedManagedStocks() {
        setCatalogueTableData([]);
        let currentStock: ManagedCatalogueStockView[] = getEditableManagedCatalogueStockView();
        let currentStockIds = currentStock.map((item: any) => item.managedStockId);
        let selectedRows: number[] = [];
        if (stocks.selectAllFilter) {
          dispatch(getStockTableOptimised({					
                keyword: stocks.keyword,
                searchPdes: stocks.searchPdes,
                searchBarcodes: stocks.searchBarcodes,
                offset: null,
                limit: null,           
                supplierIds: stocks.supplierIdFilter == undefined? []: [stocks.supplierIdFilter],
                departmentIds: stocks.departmentIdFilter == undefined? []: [stocks.departmentIdFilter],
                subdepartmentIds: stocks.subdepartmentIdFilter == undefined? []: [stocks.subdepartmentIdFilter],
                manufacturerIds: stocks.manufacturerIdFilter == undefined? []: [stocks.manufacturerIdFilter],
                stockGroupIds: stocks.stockGroupIdFilter == undefined? []: [stocks.stockGroupIdFilter],
                active: stocks.activeFilter,
                ethical: stocks.ethicalFilter,
                schedule: stocks.scheduleFilter,
                pbs: stocks.pbsFilter,					
            }))
            .then((response)=>{
                const dataToAdd = response.data.filter(x=> !currentStockIds.includes(x.id));
                dataToAdd.forEach((data) => {                               
                    currentStock.push({ managedStockId: data.id, storeStockId: data.stockId, name: data.name, quantity: 1, value: 0, type: 0, catalogueId: 0, description: "" , startDate: null, startTime: null, endDate: null, endTime: null });                               
                });
                setCatalogueTableData(currentStock);
                dispatch(updateCatalogueModelField({ key: "catalogueStocks", value: currentStock }));
                handleChange("managedStockPopup", false);

            });
            return;
        } else {
            selectedRows = getRowIds(stocks.selectedRows);
        }
        const chunkSize = 100;
        let numChunks = Math.ceil(selectedRows.length / chunkSize);
        for (let index = 0; index < numChunks; index++) {
            // Sets the progress bar to the current percentage
            setImportPercentage(Math.round((index / selectedRows.length) * 100));
            let start = index * chunkSize;
            let end = start + chunkSize;
            let chunk = selectedRows.slice(start, end);
            await dispatch(getStockTable({ ids: chunk })).then(async (res) => {
                await res.data.forEach((model) => {
                    if (selectedRows.includes(model.id) && !currentStockIds.includes(model.id)) {                       
                        currentStock.push({ managedStockId: model.id, storeStockId: model.stockId, name: model.name, quantity: 1, value: 0, type: 0, catalogueId: 0, description: "" , startDate: null, startTime: null, endDate: null, endTime: null }); 
                    }
                });
            });
        }
        setCatalogueTableData(currentStock);
        dispatch(updateCatalogueModelField({ key: "catalogueStocks", value: currentStock }));
        handleChange("managedStockPopup", false);
        setImportPercentage(0); 
    }

    return (
        <Row>
            <Col xs={12}>
                <CatalogueDeletePopup
                    isDeleting = {isDeletingSelectedStock}
                    showPopup = {showDeletePopup}
                    selectedRowsCount = {catalogue.selectedStocks.length}
                    closeDeletePopup = {()=> setShowDeletePopup(false)}
                    ActionDelete = {() => (user.permissions.managedStock.canDelete ? handleRemoval() : undefined)}
                />               
                <ManagedStocksPopup show={catalogue.managedStockPopup} onClose={() => handleChange("managedStockPopup", false)} onSave={saveSelectedManagedStocks}/>
                <CatalogueBulkEditPopup 
                    showPopup={showBulkEditPopup}
                    closeBulkEditPopup={() => setShowBulkEditPopup(false)}
                    ActionUpdate={(updateData) => {
                        
                        const ids: number[] | undefined = catelogueStocksGridRef.current?.api.getSelectedRows().map((row: ManagedCatalogueStockView)=> row.managedStockId);                       
                        let dataSet = getEditableManagedCatalogueStockView();
                        setCatalogueTableData([]);
                        ids?.forEach((selRow) => {
                            const dataLocation = dataSet.findIndex(x=>x.managedStockId == selRow);
                            dataSet[dataLocation].quantity = updateData.quantity == null? dataSet[dataLocation].quantity: updateData.quantity;
                            dataSet[dataLocation].type = updateData.promoType == null? dataSet[dataLocation].type: updateData.promoType;
                            dataSet[dataLocation].value = updateData.value == null? dataSet[dataLocation].value: updateData.value;
                        });
                      
                        dispatch(updateCatalogueModelField({ key: "catalogueStocks", value: dataSet }));
                        setShowBulkEditPopup(false);   
                    }}
                    />
                <ImportWizard
                    title="Catalogues"
                    display={catalogue.importWizardPopup}
                    handleClose={() => {
                        if (terminateWorkersRef.current) terminateWorkersRef.current();
                        handleChange("importWizardPopup", false);
                    }}
                    importAsync={(i) => importStockAsync(i)}
                    customColumns={importWizardExtraMatches}
                    matchAgainst="Stocks"
                    finish={() => handleChange("importWizardPopup", false)}
                    importPercentage={importPercentage}
                />            

                <AgGridToolbar
                    search={true}
                    ref={toolbarRef}
                    className="pb-1"
                    handleSubmit={(searchState, filterState) => {
                        dispatch(addAGGridSelectedStocks([]));
                        catelogueStocksGridRef.current?.api.deselectAll();
                        catelogueStocksGridRef.current?.api.setGridOption('includeHiddenColumnsInQuickFilter', true)
                        catelogueStocksGridRef.current?.api.setGridOption('quickFilterText', searchState?.keyword);
                    }}                      
                    searchProps={
                        {placeholder: "by Name" + (searchPdeList == true ?" / PDE":"" ) + (searchApnList== true? " / APN" : ""),customSearch: CustomSearchButton(), hideContains: true}
                    }
                    children={(
                            <div className="d-inline-flex gap-1">
                                { 
                                (catalogue.selectedStocks != undefined && catalogue.selectedStocks.length != 0) &&									
                                    <Z.Button variant="light" className="h-100" disabled={true} buttonText={catalogue.selectedStocks.length + " Selected"}/>
                                }
                                {catalogue.selectedStocks.length > 1 &&
                                   <Z.Button variant="light" className="me-1" onClick={() => setShowBulkEditPopup(true)}   style={{height: 40}}> <i className="mdi mdi-pencil"></i></Z.Button>
                                }
                                <ZTooltip text="Refresh">
                                    <Z.Button icon={ZIconType.Refresh} buttonSize="md" onClick={() => reLoadTable()} disabled={!user.permissions.priceGroups.canView} />
                                </ZTooltip>

                                <ZTooltip text="Add Managed Stock">
                                    <Z.Button
                                        size="sm"
                                        className="btn-icon custom-btn-icon "
                                        onClick={user.permissions.priceGroups.canImport ? () => handleChange("managedStockPopup", true) : undefined}
                                        disabled={!user.permissions.promotions.canCreate || !user.permissions.promotions.canUpdate} 
                                        icon={ZIconType.Add}
                                        iconSize="18px"
                                        style={{height: 40}}/>
                                </ZTooltip>

                                <ZTooltip text={
                                    catalogue.selectedStocks.length == 0 ? `Please select a row to delete`:										  
                                    catalogue.selectedStocks.length > 0 ? `Delete ${catalogue.selectedStocks.length} rows` :
                                    catalogue.selectedStocks.length == catalogue.model.catalogueStocks.length ? `Delete all rows`:
                                        "Please select a row to delete"}>
                                    <Z.Button icon={ZIconType.Delete} buttonSize="md"  onClick={() => (user.permissions.managedStock.canDelete ? setShowDeletePopup(true) : undefined)} 
                                        disabled={!user.permissions.promotions.canDelete || catalogue.selectedStocks.length < 1 } />
                                </ZTooltip>

                                <ZTooltip text="Import From Spreadsheet">
                                    <Z.Button
                                        size="sm"
                                        className="btn-icon custom-btn-icon"
                                        onClick={user.permissions.promotions.canImport ? () => handleChange("importWizardPopup", true) : undefined}
                                        disabled={!user.permissions.promotions.canCreate || !user.permissions.promotions.canUpdate} 
                                        icon={ZIconType.Upload}
                                        iconSize="18px"
                                        style={{height: 40}}
                                        />
                                </ZTooltip>
                                <Dropdown>
                                    <ZTooltip text="Export">
                                        <Dropdown.Toggle variant="light" className="btn-icon custom-btn-icon" style={{ height: 40 }}>
                                            <ZIcon icon={ZIconType.Download} size="18px" />
                                        </Dropdown.Toggle>
                                    </ZTooltip>
                                    <Dropdown.Menu className="w-auto">
                                        <Dropdown.Item className="d-inline-flex align-items-center gap-1" 
                                            onClick={() => {
                                                    catelogueStocksGridRef.current?.api.exportDataAsCsv(getCatalogStockCsvDataFormatter(catalogue.model.name)); 
                                                }}>
                                                <ZIcon icon={ZIconType.File} /> CSV File</Dropdown.Item>
                                        <Dropdown.Item className="d-inline-flex align-items-center gap-1" onClick={() => {
                                            let filters="";
                                            if(catalogue.keyword != null)
                                                filters = "Search: "+ catalogue.keyword+ ", \r\n";
                                            const spreadSheets = [];
                                            spreadSheets.push(catelogueStocksGridRef.current?.api.getSheetDataForExcel(getCatalogStockCoverPage(filters)));
                                            spreadSheets.push(catelogueStocksGridRef.current!.api.getSheetDataForExcel(getCatalogStockDataFormatter()));
                                            catelogueStocksGridRef.current!.api.exportMultipleSheetsAsExcel({
                                                data: spreadSheets,
                                                fileName: catalogue.model.name + "_" + new Date().toLocaleDateString('en-AU', {
                                                    day : 'numeric',
                                                    month : 'short',
                                                    year : 'numeric',
                                                    hour : '2-digit',
                                                    minute : '2-digit'
                                                }).split(' ').join('-').replace(',', '') +".xlsx"
                                            });
                                        }}><ZIcon icon={ZIconType.Excel} /> Excel File</Dropdown.Item>									
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        )}
                    />
                <AgGridReact
                        ref={catelogueStocksGridRef}                                    
                        columnDefs={getCatalogueStocksConfig(user, apnList, pdeList, searchApnList, searchPdeList)}
                        rowData={catalogueTableData}
                        pagination={true}
                        paginationPageSize={20}
                        className="ag-theme-quartz ag-theme-custom w-100"
                        containerStyle={{ height: "57dvh" }}
                        rowSelection="multiple"
                        suppressRowClickSelection={true}
                        suppressContextMenu
                        singleClickEdit
                        editType="fullRow"
                        stopEditingWhenCellsLoseFocus={true}
                        enterNavigatesVertically={true}
                        enterNavigatesVerticallyAfterEdit={true}
                        onSelectionChanged={(e) => {
                            let formatedData:{
                                positon: number,
                                id: number
                            } [] = []
                            catelogueStocksGridRef.current?.api.getSelectedRows().forEach((xe: any) => formatedData.push({ positon: 0, id: xe.id}));
                            dispatch(addAGGridSelectedStocks(formatedData));
                        }}
                        onRowSelected={() => {
                            let formatedData:{
                                positon: number,
                                id: number
                            } [] = []
                            catelogueStocksGridRef.current?.api.getSelectedRows().forEach((xe: any) => formatedData.push({ positon: 0, id: xe.id}));
                            dispatch(addAGGridSelectedStocks(formatedData));
                        }}
                        components={{
                            baseCellRenderer: BaseCellRenderer,
                            editablePriceCellRenderer: EditablePriceCellRenderer,
                            editablePercentCellRenderer: EditablePercentCellRenderer,
                            moneyCellEditor: MoneyCellEditor,
                            percentCellEditor:PercentCellEditor
                        }}
                          onCellKeyDown={(row) => {
                            if(row.event?.key== "Enter" && row.column.getColId() == "value"){
                                var currentCell = catelogueStocksGridRef.current?.api.getFocusedCell();
                                catelogueStocksGridRef.current?.api.startEditingCell({
                                    rowIndex: currentCell?.rowIndex,
                                    colKey: currentCell?.column.colId
                                });
                            }                            
                        }}
                        onCellEditingStopped={(event)=>{
                            var dataSet = getEditableManagedCatalogueStockView();
                            const dataLocation = dataSet.findIndex(x=>x.managedStockId == event.data.managedStockId);
                            dataSet[dataLocation].quantity = event.data.quantity == null? 1: event.data.quantity;
                            dataSet[dataLocation].type = event.data.type;
                            dataSet[dataLocation].value = event.data.value == null? 0.00: event.data.value;
                            dispatch(updateCatalogueModelField({ key: "catalogueStocks", value: dataSet }));
                        }}
                    />
            </Col>
        </Row>
    );
}